import { between } from '@vee-validate/rules';
import defineRule from '../defineRule';
defineRule('between', (value, [min, max], { field }) => {
    return between(value, [min, max]) || `Please enter a valid ${field.toLowerCase()}`;
});
